import { defineAsyncComponent } from 'vue';

export { default } from './TheFooter.vue';

export const FooterGuest = defineAsyncComponent(() => import('./FooterGuest.vue'));

export const FooterAuth = defineAsyncComponent(() => import('./FooterAuth.vue'));

export const FooterAuthLinks = defineAsyncComponent(() => import('./FooterAuthLinks.vue'));

export * from './FooterAuth';
